var map = {
	"./icon-contact.svg": 25,
	"./icon-exclamation-mark.svg": 26,
	"./icon-facebook.svg": 27,
	"./icon-instagram.svg": 28,
	"./icon-linkedin.svg": 29,
	"./logo-wijs-breda.svg": 30,
	"./mask-w.svg": 31,
	"./shape-bottom.svg": 32,
	"./shape-footer.svg": 33,
	"./shape-top.svg": 34
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24;